import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

type StyleProps = {
  hasSplitBackgroundColor: boolean;
  imageSource: string;
};

const useStyles = createUseStyles(
  ({
    brandColors: {
      background: { light1, light2 },
    },
    breakpoints: { md },
  }: CmsWrenchTheme) => {
    const mediaQueryMinScreenMD = `@media (min-width: ${md}px)`;

    return {
      container: ({ hasSplitBackgroundColor }: StyleProps) => ({
        background: hasSplitBackgroundColor
          ? `linear-gradient(to top, ${light2} 0%, ${light2} 66%, ${light1} 66%, ${light1} 100%)`
          : undefined,
      }),
      image: ({ imageSource }: StyleProps) => ({
        backgroundImage: `url(${imageSource})`,
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        height: 174,
        [mediaQueryMinScreenMD]: {
          height: 375,
        },
      }),
    };
  }
);

export default useStyles;
